export const formatTwoDecimalPlaces = (amount: number): string => {
	return amount ? parseFloat(amount.toFixed(2)).toString() : "";
};
